import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { buildPostQuery } from 'src/utils/router';
import { createSlug } from 'src/utils/string';
import config from 'config/config';

const PostLink = ({ post, community, children, extraArgs, onClick, disabled }) => {
  const postType = post.postTypeId === config.api.postTypes.POLL ? 'polls' : 'posts';
  const privatePrefix = post.isPrivate ? '/private' : '';
  const postId = post.postId || post.id;
  const extraParams = extraArgs ? convertObjectToParams(extraArgs) : '';
  const linkExtraParams = extraParams ? `?${extraParams}` : '';
  const linkToPost = `/${community.slug}/${postType}${privatePrefix}/${postId}/${createSlug(post.title)}${linkExtraParams}`;
  const hrefParams = extraArgs ? `&${extraParams}` : '';
  const href = buildPostQuery(post, community, hrefParams);
  const seoParams = linkExtraParams === '' ? {} : {rel: 'nofollow ugc'};

  if (disabled) {
    return (
      <a href="#" onClick={onClick}>{children || post.title}</a>
    );
  }

  return (
    <Link
      as={linkToPost}
      href={href}
    >
      <a onClick={onClick} {...seoParams} >{children || post.title}</a>
    </Link>
  );
};

const convertObjectToParams = (obj) => {
  const entries = Object.entries(obj);
  if (entries.length === 0) return '';

  return entries
    .map(([key, val]) => val === '' ? key : `${key}=${val}`)
    .join('&');
};

PostLink.propTypes = {
  community: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  extraArgs: PropTypes.object,
  onClick: PropTypes.func,
};

PostLink.defaultProps = {
  extraArgs: {},
  onClick: () => {},
  disabled: false,
};

export default PostLink;
